import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import './emptyRecord.scss';

export const EmptyRecord = ({ message }) => {
  return (
    <div className="empty_outstanding">
      <div className="petIcons">
        <Icon icon="inbox" />
      </div>
      {message || 'No records found.'}
    </div>
  );
};

EmptyRecord.propTypes = {
  message: PropTypes.string
};
